import { render } from "./Confirmation.vue?vue&type=template&id=33915f93"
import script from "./Confirmation.vue?vue&type=script&setup=true&lang=js"
export * from "./Confirmation.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Components/Common/Confirmation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33915f93"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33915f93', __exports__)) {
    api.reload('33915f93', __exports__)
  }
  
  module.hot.accept("./Confirmation.vue?vue&type=template&id=33915f93", () => {
    api.rerender('33915f93', render)
  })

}


export default __exports__